import classNames from 'classnames';
import { h, JSX } from 'preact';

export interface TicketSystemProps {
    class?: string;
    ticketSystem: {
        type: string;
        url?: string;
        externalTicketsInfoTitle: string;
        externalTicketsInfoA: string;
        externalTicketsInfoB: string;
    };
}

export const TicketSystem = (props: TicketSystemProps): JSX.Element => (
    <div>
        {props.ticketSystem.type === 'external' && (
            <div class={classNames('bg-primary-200 p-6 rounded-lg', props.class)}>
                <div class='font-semibold'>{props.ticketSystem.externalTicketsInfoTitle}</div>
                <div class='mt-1'>
                    {props.ticketSystem.externalTicketsInfoA}
                    {props.ticketSystem.url && (
                        <a href={props.ticketSystem.url} target='_blank' class='ml-1 text-primary-900 font-semibold transition hover:text-primary-900/70'>{props.ticketSystem.url}</a>
                    )}
                    <span>.</span>
                </div>
                <div class='mt-1'>{props.ticketSystem.externalTicketsInfoB}</div>
            </div>
        )}
    </div>
);
